import { axiosBaseQuery, request } from 'react-common'
import { createApi } from '@reduxjs/toolkit/query/react'
import { FilterDrawerType } from '@/components/CourseFiltersDrawer/types'

export type FilterCategory = {
  id: string
  name: string
  attributes?: { id: string; name: string }[]
}

const ENROLLED_FILTER_CATEGORIES = 'users/me/enrolled-filter-categories'
const CATALOG_FILTER_CATEGORIES = 'users/me/catalog-filter-categories'

export const filterCategoriesApi = createApi({
  reducerPath: 'filterCategoriesApi',
  baseQuery: axiosBaseQuery(request),
  endpoints: (build) => ({
    fetchFilterCategories: build.query<FilterCategory[], FilterDrawerType>({
      query: (type) => {
        const url = type === 'enrolled' ? ENROLLED_FILTER_CATEGORIES : CATALOG_FILTER_CATEGORIES

        return { url, method: 'get' }
      },
      transformResponse: (filterCategories: FilterCategory[]) => {
        if (!filterCategories?.length) return []

        return filterCategories
      },
    }),
  }),
})

export const { useFetchFilterCategoriesQuery } = filterCategoriesApi
